import { TravelMode } from 'types/bundleTypes';
import { roundToOne } from '../components/OrderListTable/utils/roundToTwo';

export const base_Hours = 4;
export const hour_Base_Pay = 100;
export const cost_for_shift_car = base_Hours * hour_Base_Pay;

export const cost_for_shift_bike = 0;

export const car_Per_Delivery_Price = 30;

export const minRatingForBonus = 4.9;
export const bonus_For_Good_Rating_Per_Delivery_car = 2;

export const bike_Per_Delivery_Price = 40;
export const bonus_For_Good_Rating_Per_Delivery_bike = 2;

export const avgDeviationCompPercentage = 0.0085;

export const compensationModelStavanger = {
  minRatingForBonus: 4.9,
  bonusForGoodRatingPerDeliveryCar: 2,
  bonusForGoodRatingPerDeliveryBike: 2,
  carPerDeliveryPrice: 28,
  bikePerDeliveryPrice: 40,
  minTotalCompForShift: 1400,
  avgDeviationCompPercentage: 0,
};

export function calcVatForCouriers(mvaResult: boolean): number {
  if (mvaResult) {
    return 0.25;
  }
  return 0;
}

function basePayPerDeliveryCalc(
  travelMode: string,
  useOutsideOsloCompensationModel = false
) {
  if (useOutsideOsloCompensationModel) {
    if (travelMode === TravelMode.BIKE) {
      return compensationModelStavanger.bikePerDeliveryPrice;
    }
    return compensationModelStavanger.carPerDeliveryPrice;
  }
  if (travelMode === TravelMode.BIKE) {
    return bike_Per_Delivery_Price;
  }
  return car_Per_Delivery_Price;
}

function calcIsBonusDeliveries(
  totalAverageRating: number,
  useOutsideOsloCompensationModel: boolean
): boolean {
  return (
    roundToOne(totalAverageRating) >=
    (useOutsideOsloCompensationModel
      ? compensationModelStavanger.minRatingForBonus
      : minRatingForBonus)
  );
}

export function calcCompensationForNormalDeliveries(
  nrOfOrders: number,
  travelmode: string,
  totalAverageRating: number,
  useOutsideOsloCompensationModel: boolean
): number {
  const basePayPerDelivery = basePayPerDeliveryCalc(
    travelmode,
    useOutsideOsloCompensationModel
  );
  const isBonusDeliveries: boolean = calcIsBonusDeliveries(
    totalAverageRating,
    useOutsideOsloCompensationModel
  );
  const compensationForBonusDeliveries: number = isBonusDeliveries
    ? calcBonusCompensationBasedOnTravelMode(
        travelmode,
        useOutsideOsloCompensationModel
      )
    : 0;

  const payPerDelivery = basePayPerDelivery + compensationForBonusDeliveries;
  return nrOfOrders * payPerDelivery;
}

function calcCompensationForShiftCarBasedOnNrOfOrders(nrOfOrders: number) {
  return nrOfOrders > 0 ? cost_for_shift_car : cost_for_shift_bike;
}

export function calcCompensationForShift(
  nrOfOrders: number,
  travelMode: string
): number {
  if (travelMode === TravelMode.BIKE) {
    return cost_for_shift_bike;
  }
  return calcCompensationForShiftCarBasedOnNrOfOrders(nrOfOrders);
}

export function calcCompensationForShiftBasedOnTravelMode(
  travelMode: string
): number {
  if (travelMode === TravelMode.BIKE) {
    return cost_for_shift_bike;
  }
  return cost_for_shift_car;
}

export function calcBonusCompensationBasedOnTravelMode(
  travelMode: string,
  useOutsideOsloCompensationModel = false
): number {
  if (useOutsideOsloCompensationModel) {
    if (travelMode === TravelMode.BIKE) {
      return compensationModelStavanger.bonusForGoodRatingPerDeliveryBike;
    }
    return compensationModelStavanger.bonusForGoodRatingPerDeliveryCar;
  }
  if (travelMode === TravelMode.BIKE) {
    return bonus_For_Good_Rating_Per_Delivery_bike;
  }
  return bonus_For_Good_Rating_Per_Delivery_car;
}
